import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Admin/auth areas are not tracked.
const EXCLUDED_PREFIXES = ["/admin", "/login", "/post-writer"];

function isExcluded(path) {
  return EXCLUDED_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));
}

function send(payload) {
  try {
    fetch("/.netlify/functions/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never let tracking break the page */
  }
}

export default function AnalyticsTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  // Pageview on each route change
  useEffect(() => {
    const path = location.pathname;
    if (isExcluded(path)) return;
    if (lastPath.current === path) return;
    lastPath.current = path;

    send({
      type: "pageview",
      path,
      referrer: document.referrer || "",
    });
  }, [location.pathname]);

  // Link clicks (delegated, captures internal + outbound anchors)
  useEffect(() => {
    function onClick(e) {
      const anchor = e.target?.closest?.("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("#")) return;
      if (isExcluded(window.location.pathname)) return;

      send({
        type: "click",
        path: window.location.pathname,
        target: href,
      });
    }

    document.addEventListener("click", onClick, { capture: true });
    return () =>
      document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
